module.exports = __webpack_public_path__ + "media/excellusbcbs-careers-calendar@lg-aab976680cb2cc07d34daf4705e14370.png";